// extracted by mini-css-extract-plugin
export var conversationListItem = "_ww-2";
export var fullBleedList = "_ww-3";
export var messageText = "_ww-1";
export var previewText = "_ww-0";